// extracted by mini-css-extract-plugin
export default {"CreateJobCategory":"create-job-category_CreateJobCategory__k6V+5"};